import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-grid-system";
import { Icon } from "@blueprintjs/core";
import { useFormState } from "react-final-form";

const ContactConfirmation = ({ setDone }) => {
  const { values } = useFormState();
  useEffect(() => setDone(), []);
  return (
    <Container className="form-fields row confirmation">
      <Row>
        <Col>
          <div className="quote-summary">
            <h3>{values.firstname}, help is on the way!</h3>
            <p>
              Your information has been sent to a move specialist and they
              should call you in a few minutes.
            </p>
            <p>
              If you want to call one of our moving specialists, we&apos;re here
              to help!
            </p>
            <p>
              <span className="quote-summary__contact">
                <a href="tel:855-336-1151" style={{ color: "#ef4044" }}>
                  <Icon icon="phone" iconSize={20} color="#ef4044" />
                  855-336-1151
                </a>
              </span>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

ContactConfirmation.propTypes = {
  setDone: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setDone: () => dispatch({ type: "SET_DONE", done: true }),
});

export default connect(null, mapDispatchToProps)(ContactConfirmation);
